import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage author='OneShop Team' dateTime='2022-01-22' tag='Poshmark' title='Poshmark’s Easy-to-Use Return Policy'>
        <p>
          Description: "When you receive an item you don't want, you can return it for an exchange, refund, or store
          credit with Poshmark’s easy-to-use return policy."
        </p>

        <p>
          Poshmark is a well-known online marketplace for home decor, fashion, and beauty products with millions of
          active buyers and sellers. With such a big platform it is without a doubt that it has its fair share of
          encounters with a wrong item or faulty orders that require a comprehensive yet effective return policy.
        </p>
        <p>
          Poshers are protected by the Poshmark return policy called “Posh Protect”. Every time a buyer makes a purchase
          on the platform you will be given a full refund if your item was never shipped or if it does not match the
          listing description. (In this blog, we’ll get to know how to better navigate through Poshmark’s return policy
          like a pro.
        </p>

        <h3>How does Posh Protect work?</h3>
        <p>
          When you make a purchase on Poshmark the payment is not automatically released to the seller until you have
          let Poshmark know that you’ve received your order as described. Every buyer is under the Poshmark return
          window that gives 3 days after delivery to inform Poshmark through the Poshmark app or website with supporting
          photos showing that the item has been misrepresented or if the item condition has flaws and is unacceptable.{' '}
        </p>
        <p>
          Once the claim has been verified, Poshmark will send a return shipping label to have the order returned to the
          seller and issue you a refund of the full amount. Take note that all returns must be shipped back within 5
          days subject to approval to determine if it is eligible for a refund.
        </p>

        <h3>How are sales considered final?</h3>
        <p>
          All sales are considered final if the buyer does not file a claim or report a problem with their order within
          3 days after receiving their item.
        </p>

        <h3>Grounds for a refund</h3>
        <p>
          Refunds can be processed through the Poshmark website or app and buyers should submit their return request
          immediately if the following pertain to your order:
        </p>
        <ul>
          <li>Undisclosed damage</li>
          <li>Incorrect or missing item</li>
          <li>Item not as described in the listing</li>
          <li>Not authentic items</li>
          <li>Item was never received</li>
        </ul>
        <p>
          The return window is only within 3 days and if no claim has been made then the payment will be automatically
          released to the seller and the sale will be final with no grounds for refunds.
        </p>

        <h3>What’s not accepted</h3>
        <p>
          The Posh Protect policy similar to other online retail sites like eBay has certain limitations and
          restrictions that are not covered by Poshmark’s return policy such as:
        </p>
        <ul>
          <p>
            <li>
              <b>Item does not fit/change of mind</b>
              <br />
              If the item suddenly doesn’t suit your preference or does not fit you, Poshmark cannot accept those
              reasons for a return. However, you can always re-list those items on Poshmark.
            </li>
          </p>
          <p>
            <li>
              <b>Trades and offline transaction</b>
              <br />
              The Posh Protect does not cover trades or any transactions that have been completed off the Poshmark
              platform. Trading can be done on Poshmark, however, the platform does not advise poshers to participate in
              trading because there is no buyer protection. So the platform is not liable should both parties refuse to
              ship or complete the transaction as promised.
            </li>
          </p>
        </ul>

        <h3>How to prevent a return case</h3>
        <p>
          We’ve covered what buyers should know to safeguard their buyer protection, now let’s discuss how sellers can
          prevent a return case from being filed against them. Honesty and integrity mean a great deal with buyers and
          as respectable sellers it is expected that you conduct each listing and sale as honestly as you can.{' '}
        </p>
        <ul>
          <p>
            <li>
              <b>Be honest with your listing</b>
              <br />
              This means being clear, concise, and transparent with each and every one of your listings. To ensure that
              your buyers and potential customers only get the items that they expect and not falsely advertised items
              with manipulated photos.
            </li>
          </p>
          <p>
            <li>
              <b>Be detailed</b>
              <br />
              Clarity is an important detail that must never be compromised. Make sure that your listings contain
              relevant details about the item from its history, condition, and flaws. And be open when potential buyers
              send you an order inquiry it is a chance to build your rapport within the community and gain feedback
              about your closet.
            </li>
          </p>
          <p>
            <li>
              <b>Provide actual photos</b>
              <br />
              When shooting your product photos it is always best to shoot them with natural lighting and ensure that
              the item is not overshadowed by other elements in the photo. Don’t use stock photos ever when creating
              your listings, buyers are wary against fraud, and using doctored or stock photos will not lead to a sale.
            </li>
          </p>
        </ul>

        <h3>What do buyers need to provide when reporting a problem</h3>
        <p>
          The first thing that buyers must do before reporting a problem with their order is to make sure that they have
          downloaded the latest version of the app on their Android or iOS device. Once confirmed they can proceed to
          file a return by following these instructions:
        </p>
        <ol>
          <li>Launch the Poshmark app</li>
          <li>Go to your Poshmark account (Tap on the Account Tab)</li>
          <li>Hit My Purchases</li>
          <li>Choose the order you want to return</li>
          <li>Select Order Inquiry or Problems</li>
          <li>Tap on Order Not as Described</li>
          <li>Select the reason for returning the item from the dropdown menu</li>
          <li>Add high-quality images of the product (with good lighting) as proof for your return claim</li>
          <li>Describe the return in detail and include any additional details</li>
          <li>Tap on Submit</li>
        </ol>
        <p>How to request a return on the Poshmark website:</p>
        <ol>
          <li>Click on your avatar in the top-right corner of the screen</li>
          <li>Select My Purchases</li>
          <li>Choose your order</li>
          <li>Tap Problems or Order Inquiry</li>
          <li>Click Order Not as Described</li>
          <li>Upload clear, high-resolution JPG images of the item</li>
          <li>Describe the reason for returning</li>
          <li>Hit Submit</li>
        </ol>

        <h3>What happens when a return case is filed against you</h3>
        <p>
          When a buyer reports a problem with their order, Poshmark asks them to provide supporting documentation
          including photos along with a list of issues. This is then reviewed by Poshmark’s customer service before
          coming to a resolution.
        </p>
        <p>
          For sellers, we recommend that you accurately describe the item within a listing by providing a detailed
          description and include clear and original photos that fully show the condition of the item. After a review of
          all supporting material submitted by the buyer and seller, they will both be notified of the resolution via
          email.
        </p>
        <p>
          If the return request is approved, then Poshmark will send the buyer a prepaid shipping label to return the
          order back to the seller. Once the order has been delivered to the seller, Poshmark will issue a full refund
          to the buyer including any shipping and tax paid.
        </p>

        <h3>What to do upon receiving the returned item</h3>
        <p>
          Poshmark suggests that after you inspect the returned item and if it isn’t in the original condition that it
          was originally sent out, you as the seller have the opportunity to report the problem with the return to
          Poshmark. Here’s how you can report a problem with the return through the app and website:
        </p>
        <p>In the app</p>
        <ol>
          <li>Go to your Account Tab (@username).</li>
          <li>Select My Sales.</li>
          <li>Select the order.</li>
          <li>Select Problems / Order Inquiry.</li>
          <li>Select Report Problem with Return.</li>
        </ol>
        <p>On the web</p>
        <ol>
          <li>Select your profile at the top-right of the page.</li>
          <li>Select My Sales.</li>
          <li>Select the order.</li>
          <li>Select Problems/Order Inquiry.</li>
          <li>From the dropdown menu, select Report Problem with Return.</li>
        </ol>

        <p>
          If you’re a seller that has a lot of listings that you need to optimize and cross-list to different online
          marketplaces then a pro tip is to use automation software to get this task and more done as effectively and
          efficiently as possible. OneShop is a great software to get you started with its easy-to-use interface and
          readily customizable tools that leave you without worry to leave the manual and time-consuming tasks behind so
          you can focus on more important things to grow your business. OneShop also functions as your virtual assistant
          that works 24/7 to improve your reach by automating shares, follows, and more!
        </p>
        <p>
          Try it for yourself, register for free, and enjoy a 7-day trial with no commitment or credit card required.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
